// extracted by mini-css-extract-plugin
export var footerLinks = "footer-module--footer-links--Tl8N1";
export var footerLogo = "footer-module--footer-logo--R9KK4";